<template>
  <loading
    :active.sync="isLoading"
    :can-cancel="canCancel"
    :on-cancel="cancel"
    :is-full-page="fullPage"
    :height="height"
    :width="width"
    :color="color"
    :loader="loader"
    :background-color="bgColor"
  >
    <h3 class="abcccccc" v-if="useSlot">Loading ...</h3>
  </loading>
</template>

<script>
/**
 * loding component
 *
 * @author minkyoung.park@emcast.com
 */
// Import component
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      canCancel: true,
      useSlot: false,
      loader: "spinner",
      color: "#263238",
      bgColor: "#ffffff",
      height: 80,
      width: 80,
      timeout: 3000, //ms
    };
  },
  components: {
    Loading,
  },

  methods: {
    show(payload) {
      console.log("loading payload===", payload);
      if (payload) {
        this.fullPage = false;
        this.width = 30;
        this.height = 30;
      } else {
        this.fullPage = true;
      }

      this.isLoading = true;

      console.log("loading payload", this._data);
    },
    hide() {
      this.isLoading = false;
    },

    cancel() {},
  },
};
</script>

<style>
.vld-overlay {
  z-index: 99999999 !important;
}
</style>
